import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { useLocalStorage } from 'react-use';

import { DialogHeader } from '../../../../components/Dialog/DialogUiRedesign/DialogHeader';
import { useMediaQuery } from '../../../../hooks/useMediaQuery';
import { auth } from '../../../../services/auth';
import { useStores } from '../../../../stores/useStores';
import type { ChooseCountryProps } from '../../ChooseCountryDialog/types';
import { RedesignContainer } from '../RedesignContainer/RedesignContainer';

import { ChooseCountryComponentRedesign } from './ChooseCountryComponentRedesign';
import styles from './ChooseCountryRedesign.module.scss';

interface ChooseCountryWizardStepRedesignProps {
  /** Overrides closing the portal after the sign-out (used by the /native flow). */
  onGoBack?: () => void;
}

export const ChooseCountryWizardStepRedesign = observer(function ChooseCountryWizardStepRedesign({
  onGoBack,
  ...props
}: ChooseCountryProps & ChooseCountryWizardStepRedesignProps) {
  const [_signUpMarketingConsentsLS, _setSignUpMarketingConsentsLS, removeSignUpMarketingConsentsLS] = useLocalStorage<
    Record<string, boolean>
  >('signup-marketing-consents', {});
  const { portalStore } = useStores();
  const { t } = useTranslation();
  const isDesktop = useMediaQuery('(min-width: 768px)');

  const onClose = async () => {
    removeSignUpMarketingConsentsLS();
    await auth.signOut();

    if (onGoBack) {
      onGoBack();
      return;
    }

    portalStore.closePortal();
  };

  return (
    <RedesignContainer className={styles.container}>
      <DialogHeader
        className={styles.dialogHeader}
        decorationsWrapperClassName={styles.dialogHeaderDecorationsWrapperClassName}
        title={t('settings.chooseYourSettings')}
        titleClassName={styles.dialogHeaderTitle}
        titleDataTestId="email-verification-title"
        {...(isDesktop ? { onClose: onClose } : { onGoBack: onClose })}
      />
      <ChooseCountryComponentRedesign {...props} componentType="portal" />
    </RedesignContainer>
  );
});
